import { Component, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { TimeOffRequestRules } from '@app/models/time-off-v3/time-off-request-rules.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { TimeOffCreateFlowService } from '@app/modules/time-off-v3/services';
import { TranslatableKey } from '@app/types/translatable.type';
import { Subscription } from 'rxjs';
import { AccrualScheduleDetailsCardComponent } from '../../components';

@Component({
    selector: 'app-policy-review-form',
    templateUrl: './policy-review.template.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class PolicyReviewForm extends BaseForm implements OnInit {
    @ViewChild('accrualScheduleCard') accrualScheduleCard!: AccrualScheduleDetailsCardComponent;

    timeOffPolicy = new TimeOffPolicy();
    timeOffRequestRule = new TimeOffRequestRules();
    unitOfTime: TranslatableKey = 'time-off-v3.days';

    private timeOffPolicySubscription!: Subscription;
    private timeOffRequestRulesSubscription!: Subscription;

    constructor(private timeOffCreateFlowService: TimeOffCreateFlowService) {
        super();
    }

    ngOnInit(): void {
        this.timeOffPolicySubscription = this.timeOffCreateFlowService.timeOffPolicy$.subscribe((policy) => {
            this.timeOffPolicy = policy;
            // Need to rerun the component to show correct data on policy value changes
            this.accrualScheduleCard?.initialize();
            this.unitOfTime = this.timeOffPolicy.timeOffType.unitOfTimePluralTranslation;
        });

        this.timeOffRequestRulesSubscription = this.timeOffCreateFlowService.timeOffRequestRules$.subscribe(
            (timeOffRequestRules) => {
                // Need to rerun the component to show correct data on policy value changes
                this.accrualScheduleCard?.initialize();
                this.timeOffRequestRule = timeOffRequestRules;
            }
        );
    }

    ngOnDestroy(): void {
        this.timeOffPolicySubscription.unsubscribe();
        this.timeOffRequestRulesSubscription.unsubscribe();
    }
}
